import styled from 'styled-components';
import media from '../../constants/media';
import theme from '../../constants/theme/theme';

export const Container = styled.div`
	max-width: 75%;
	margin: 0 auto;
	padding: 20px;
	${media.mobileOnly`padding-top: 70px;`};
	${media.mobileAndTabletOnly`max-width: 100%;`};
`;

export const TabsContainer = styled.div`
	padding: 20px;
	box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
	border-radius: 0 10px 10px 10px;

	${media.mobileOnly`
		border-radius: 10px;
		`};
`;

export const TabTitles = styled.ul`
	list-style: none;
	background-color: ${theme.colors.white};
	margin-top: 10px;
	padding-top: 10px;
	display: flex;
	gap: 1px;
	width: max-content;

	${media.mobileOnly`
		width: 100%;
		overflow-x: scroll;
		padding-bottom: 10px;
		gap: 5px;
		`};
`;

export const TabTitle = styled.li<{ active?: boolean }>`
	padding: 20px 30px;
	background-color: ${theme.colors.white};
	box-shadow: 0px -10px 20px rgba(0, 0, 0, 0.1) ${({ active }) => (active ? '' : ', inset 0 0 40px rgba(0, 0, 0, 0.08)')};
	border-radius: 15px 15px 0 0;
	font-size: 1.5rem;
	font-weight: 600;
	white-space: nowrap;
	cursor: pointer;

	${media.mobileOnly`
		padding: 5px 10px;
		border-radius: unset;
		box-shadow: unset;
		border-bottom: ${({ active }) => (active ? `1px solid ${theme.colors.primary}` : 'none')}; ;
		`};
`;

export const TabContent = styled.div<{ active?: boolean }>`
	display: ${({ active }) => (active ? 'block' : 'none')};
`;
